import Image from 'next/image';
import { TextLink } from '@/components/TextLink';

type AppStoreButtonsProps = {
  onStoreClick?: (href: string) => void;
  googleStoreLink?: string;
  appleStoreLink?: string;
};

export const AppStoreButtons = ({ googleStoreLink, appleStoreLink, onStoreClick }: AppStoreButtonsProps) => (
  <div className="-mx-3 mb-4">
    <div className="inline-block align-top py-0 px-3">
      {appleStoreLink ? (
        <TextLink
          onClick={() => {
            onStoreClick?.(appleStoreLink);
          }}
          data-automation="ZA.button-Apple-store"
          aria-label="Apple App Store"
          rel="noopener noreferrer"
          href={appleStoreLink}
          target="_blank"
        >
          <Image src="/images/apple-app-store-badge.svg" height={60} width={142} alt="" />
        </TextLink>
      ) : null}
    </div>

    <div className="inline-block align-top py-0 px-3">
      {googleStoreLink ? (
        <TextLink
          onClick={() => {
            onStoreClick?.(googleStoreLink);
          }}
          data-automation="ZA.button-Google-play-store"
          rel="noopener noreferrer"
          aria-label="Google Play"
          href={googleStoreLink}
          target="_blank"
        >
          <Image src="/images/google-play-badge.svg" height={60} width={157} alt="" />
        </TextLink>
      ) : null}
    </div>
  </div>
);
